

















































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';
import MyForm from '@/mixins/form';

@Component
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  handleSubmit() {
    this.form.validateFields(async (err: any, values: any) => {
      if (!err) {
        const res = await this.$store.dispatch('stadium/addGround', {
          stadium_id: this.stadiumId,
          ...values,
        });

        if (res && res.Message && res.Message === 'success') {
          this.$message.success('添加成功');
          this.handleCancel();
        } else {
          this.$message.error('添加失败');
        }
      }
    });
  }
}
